import React from 'react'
import cx from 'classnames'
import styles from './BlockCaption.scss'
import Textarea from 'react-textarea-autosize'

export class BlockCaption extends React.Component {
  updateCaption = (e) => {
    this.props.blockProps.onChange({caption: e.target.value})
  }

  onKeyDown = (e) => {
    // up/down arrows now handled by letting key events fall through to parent
    const DELETE = 8

    if (e.keyCode === DELETE) {
      // prevent hitting backspace in a caption from deleting blocks
      e.stopPropagation()
    }
  }

  render () {
    const data = this.props.block.getData()
    const caption = data.get('caption')
    const captionEmpty = !caption || caption.length === 0
    const captionClass = cx(styles.BlockCaption, captionEmpty && styles.placeholder)

    return (
      <figcaption className={captionClass} onKeyDown={this.onKeyDown}>
        <Textarea
          contentEditable='true'
          suppressContentEditableWarning
          value={caption || ''}
          placeholder='Write a caption'
          onChange={this.updateCaption}
          className={styles.textarea} />
        <div className={styles.closeButton} />
      </figcaption>
    )
  }
}
